import React, { FC } from 'react';

import { IMerchant, INavItem } from 'src/prize/types/shoppe';

import Aragosta from '../../templates/Aragosta';

import styles from './index.module.sass';

interface RaosProps {
  links?: INavItem;
  merchant: IMerchant;
}

const Raos: FC<RaosProps> = ({ links, merchant }) => (
  <Aragosta className={{ container: styles.container }} links={links} merchant={merchant} />
);

export default Raos;
